export const MENTION_REGEX = /@\[([^[]+?)]\(([\w\d=]+)\)/;
export const MENTION_REGEX_GLOBAL = new RegExp(MENTION_REGEX.source, 'g');
export const mentionIdRegex = (id: string): RegExp =>
  new RegExp(`@\\[[^\\[]+?]\\(${id}\\)`, 'g');

export const escapeRegex = (input: string): string => {
  return input.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
};
